import { BaseHolding } from './base-holding';

export class Security extends BaseHolding {
	public asOfDate: Date;
	public assetClass: string;
	public inceptionDate: Date;
	public blackrockFund: boolean;
	public assetClassCategory: string;
	public navMonthlyPerfOneYear: number;
	public navMonthlyPerfFiveYears: number;
	public navMonthlyPerfTenYears: number;
	public navMonthlyPerfYTD: number;
	public navMonthlySinceInception: number;
	public navMonthlyGrossRatio: number;
	public navMonthlySecYield: number;
	public portfolioId: number;
	public parentPortfolioId: number;
	public stdNavPerfOneYear: number;
	public stdNavPerfFiveYears: number;
	public stdNavPerfTenYears: number;
	public stdNavPerfSinceInception: number;
	public stdPerfGrossRatio: number;
	public stdSecYield: number;
	public stdMktPerfOneYear: number;
	public stdMktPerfFiveYears: number;
	public stdMktPerfTenYears: number;
	public stdMktPerfSinceInception: number;
	public stdPerfAsOfDate: Date;
	public morningstarCategory: string;
	public morningstarFundId: string;
	public unSubSecYield: number;
	public netExpRatio: number;
	public prospectusExpWaiverType: string;
	public prospectusExpWaiverDate: Date;
	public otherIdentifiers: any;
	public isUnresolved: boolean; // for PE use, to identify unresolved securities

	public toString(): any {
		const securityObj = {};
		Object.keys(this).forEach(property => {
			if (this[property] instanceof Date) {
				securityObj[property] = this[property].getMonth() + 1 + '/' + this[property].getDate() + '/' + this[property].getFullYear();
			} else {
				securityObj[property] = this[property];
			}
		});
		return securityObj;
	}
}
